module.exports = __webpack_public_path__ + "assets/img/honor4.44ca91f9.png";